// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"LoadingSpinner_spinnerContainer__wsK6w","loading":"LoadingSpinner_loading__05pMf"};